const srids = [
	{ srid: 3006, name: "SWEREF 99 TM" },
    { srid: 3007, name: "SWEREF 99 12 00" },
    { srid: 3008, name: "SWEREF 99 13 30" },
    { srid: 3009, name: "SWEREF 99 15 00" },
    { srid: 3010, name: "SWEREF 99 16 30" },
    { srid: 3011, name: "SWEREF 99 18 00" },
    { srid: 3012, name: "SWEREF 99 14 15" },
    { srid: 3013, name: "SWEREF 99 15 45" },
    { srid: 3014, name: "SWEREF 99 17 15" },
    { srid: 3015, name: "SWEREF 99 18 45" },
    { srid: 3016, name: "SWEREF 99 20 15" },
    { srid: 3017, name: "SWEREF 99 21 45" },
    { srid: 3018, name: "SWEREF 99 23 15" },
    { srid: 4619, name: "SWEREF 99 lat long" },
    { srid: 4976, name: "SWEREF 99 cart" }
]

export default srids

export const sridName = (srid) => {
    const system = srids.find((s) => s.srid === srid);
    return system ? system.name : null;
}



// WEBPACK FOOTER //
// ./src/constants/srids.js